import styled from "styled-components";

export const ForgetPasswordStep3Styled = styled.div`
  margin: auto;
  width: 100%;
  position: relative;
  .register_header {
    margin-bottom: 12px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .register_title {
    margin-bottom: 14px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.GRAY_12};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .register_email {
    margin-bottom: 20px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .new_password {
    margin-bottom: 12px;
  }
  .confirm_new_password {
    margin-bottom: 30px;
  }
  .password_change_successfull {
    position: absolute;
    top: 0;
    left: -50px;
  }
`;
